/**
 * Created by josh on 17/08/11.
 * 路由元信息 meta 字段
 * path: string;
 * component?: Component;
 * name?: string; // for named routes (命名路由)
 * components?: { [name: string]: Component }; // for named views (命名视图组件)
 * redirect?: string | Location | Function; //路由重定向
 * alias?: string | Array<string>; 别名
 * children?: Array<RouteConfig>; // for nested routes
 * beforeEnter?: (route: Route, redirect: Function, next: Function) => void; //路由钩子
 * meta?: any; //参数
 */
// 登录
// const home = resolve => require(['../views/home.vue'], resolve);
// const subRouter = resolve => require(['../components/router.vue'], resolve);

// 个人实名
const personalName = () =>
  import ('../views/realName/personalName.vue');
// 个人人工实名
const artPersonalMsg = () =>
  import ('../views/realName/artPersonalMsg.vue');
// 企业实名
const groupName = () =>
  import ('../views/realName/groupName.vue');
// 企业人工 信息
const artGroupMsg = () =>
  import ('../views/realName/artGroupMsg.vue');
// 企业人工 照片
const artGroupPhoto = () =>
  import ('../views/realName/artGroupPhoto.vue');
// 企业人工 银行信息
const artGroupBank = () =>
  import ('../views/realName/artGroupBank.vue');
// 个人芝麻认证二维码页面
const personQrcode = () =>
  import ('../views/realName/personQrcode.vue');
// 实名认证结果
const approveResult = () =>
  import ('../views/realName/approveResult.vue');

export default [
  // 个人实名
  {
    path: 'personalName',
    name: 'PersonalName',
    component: personalName
  },
  // 个人人工实名
  {
    path: 'artpersonalMsg',
    name: 'artpersonalMsg',
    component: artPersonalMsg
  },
  // 企业实名认证
  {
    path: 'groupName',
    name: 'GroupName',
    component: groupName
  },
  // 企业人工实名 信息
  {
    path: 'artGroupMsg',
    name: 'ArtGroupMsg',
    component: artGroupMsg
  },
  // 企业人工实名 图片
  {
    path: 'artGroupPhoto',
    name: 'ArtGroupPhoto',
    component: artGroupPhoto
  },
  // 个人芝麻认证二维码
  {
    path: 'personQrcode',
    name: 'PersonQrcode',
    component: personQrcode
  },
  // 企业人工实名 银行信息
  {
    path: 'artGroupBank',
    name: 'ArtGroupBank',
    component: artGroupBank
  },
  // 实名认证结果
  {
    path: 'approveResult',
    name: 'ApproveResult',
    component: approveResult
  }
];



// WEBPACK FOOTER //
// ./src/pages/admin/router/attestation.js